/* eslint-disable */
import React, {Component} from 'react';
import {Input, Grid} from 'react-spreadsheet-grid';
import set from 'lodash.set';
import {Button, OverlayTrigger, Popover} from "react-bootstrap";


export class AddFieldTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            columns: [],
            data: [],
            save: -1,
            row_save: {
                "area": 0,
                "name": "",
            }
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.populateFieldsData();
    }

    handleSubmit(event) {
        this.PostResponse()
        event.preventDefault();
        this.setState({data: [{name: '', area: ''}]})
    }

    async PostResponse() {
        this.setState({save: 0})
        const token = this.props.token;
        await fetch('api/field?area=' + this.state.row_save.area + '&name=' + this.state.row_save.name, {
            method: 'POST',
            headers: !token ? {} : {'Authorization': `Bearer ${token}`},
        }).then((response) => {
            if (response.ok) {
                response.json().then((result) => {
                    this.props.addField(result)
                });
                this.setState({save: 2, row_save:{'area':0, 'name':''}})
                setTimeout(()=>this.setState({save: -1}),3000)
            }else {
                this.setState({save: 1})
                setTimeout(()=>this.setState({save: -1}),3000)
            }
        });
    }


    render() {
        let save=''
        switch (this.state.save) {
            case 0:
                save = 'Идет добавление...'
                break
            case 1:
                save = 'Ошибка'
                break
            case 2:
                save = 'Поле успешно добавлено'
                break
            default:
                save = ''
                break
        }
        return (
            <div id='add-field-table' key =''>
                <Grid
                    key=''
                    columns={this.state.columns}
                    rows={this.state.data}
                    isScrollable={false}
                    focusOnSingleClick={true}
                    getRowKey={row => row.id}
                    rowHeight={90}
                />
                <div className="btn-container">
                <OverlayTrigger
                    trigger="click"
                    show={save!==''}
                    placement="left"
                    overlay={<Popover className={'pop'+this.state.save}> {save}</Popover>}
                >
                        <Button className="add-field-btn" onClick={this.handleSubmit}>Добавить</Button>
                </OverlayTrigger>
                </div>
            </div>);
    }


    async populateFieldsData() {
        const numberFormat = new Intl.NumberFormat('ru-RU')

        function formatCell(value, element = false) {
            return value ? (numberFormat.format(value.toString().replace(',', '.')).replace(',', '.')) : '0'
        }

        const onFieldChange = (rowId, field) => (value1) => {
            let value = value1
            if (field === 'area')
                value = value1.replace(/\s/g, "")
            set(this.state.data[0], field, value);
            this.state.row_save[field] = value
        }

        const columns = [
            {
                title: 'Наименование нового поля',
                value: (row, {focus}) => {
                    return (
                        <Input
                            placeholder='Поле'
                            value={row.name}
                            focus={focus}
                            selectTextOnFocus={true}
                            onChange={onFieldChange(row.id, 'name')}
                        />
                    );
                },
                id: 'name',
            }, {
                title: 'Площадь нового поля, га',
                value: (row, {focus}) => {
                    return (
                        <div className={row.area == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.area)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onFieldChange(row.id, 'area')}
                            />
                        </div>
                    );
                },
                id: 'area',
            }
        ]

        this.setState({
            data: [{name: '', area: '0'}],
            columns: columns,
        });
    }

}
